import { render, staticRenderFns } from "./FodderDistribution.vue?vue&type=template&id=180dde48&scoped=true&"
import script from "./FodderDistribution.vue?vue&type=script&lang=js&"
export * from "./FodderDistribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180dde48",
  null
  
)

export default component.exports